/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAuthDispatchControl.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/auth_dispatch_control";

export class AutogenModelAuthDispatchControl<RowType extends ModelRow> extends Endpoint<RowType, RowAuthDispatchControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAuthDispatchControl extends ModelRow<RowAuthDispatchControlFields> {
	constructor(values?: Partial<RowAuthDispatchControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAuthDispatchControlFields {
	allow_overrides: string;
	auto_pay_rates: string;
	auto_rate: string;
	brk_qual_profile: string;
	brk_quote_template: number;
	carrier_assignment_prompt: string;
	carrier_select_expand_all: string;
	carrier_selection_sort: string;
	check_call_warning: number;
	create_location_from_stop: string;
	def_load_to_radius: number;
	def_loc_radius: number;
	default_posting_user_role: string;
	delivery_warning: number;
	dimension_surchg: string;
	dispatch_by: string;
	driver_assignments: string;
	enable_authorized: string;
	enable_customer_add_google: string;
	enable_google_places: string;
	enable_location_add_google: string;
	enable_manifesting: string;
	enable_stop_add_google: string;
	enforce_billto: string;
	enforce_credit: string;
	enforce_max_pay: string;
	enforce_regulatory: string;
	enforce_revenu_cod: string;
	enforce_shipper_id: string;
	enforce_target_pay: string;
	enforce_void_hist: string;
	equipment_match: string;
	est_fuel_surcharge: string;
	google_places_entry_delay: number;
	is_container_active: string;
	mandatory_carrier_ratings: string;
	max_loads_per_tractor: number;
	mpact_host_url: string;
	mpact_key_last_entered: Date;
	mpact_smart_api_key: string;
	pickup_warning: number;
	prevent_dsp_hold: string;
	rate_carrier: string;
	rate_exception_uom_list: string;
	rate_using_tariff: string;
	rate_using_tariff_codes: string;
	rating_trigger_code: string;
	recurring_override: string;
	req_unassign_reason: string;
	require_departure: string;
	rerate_consigned_bfg: string;
	set_bol_received: string;
	show_btm: string;
	showas_location: string;
	use_load_city: string;
	use_primary_eq: string;
	target_pay_calc: string;
	trailer_sharing: string;
	unassign_reason: string;
}

